export const occupationCollectionGuard = 'GET /occupations';
